import type { auth } from './auth'

import { inferAdditionalFields } from 'better-auth/client/plugins'
import { createAuthClient } from 'better-auth/react'

import { toast } from '@/components/ui/toast'

export const authClient = createAuthClient({
  plugins: [inferAdditionalFields<typeof auth>()],
  fetchOptions: {
    onError(e) {
      if (e.error.status === 429) {
        toast.add({ type: 'error', title: 'Too many requests. Please try again later.' })
      }
    },
  },
})

export const { useSession } = authClient

export type User = (typeof authClient.$Infer.Session)['user']
